export default function encodeQueryString(map: {[key: string]: any}) {
  return Object
    .keys(map)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(map[k])}`)
    .join('&')
}